import { computed, ref, onMounted } from "vue"
import { useStore } from "vuex"

export default {
    name: "GroupPost",
    props: {
        result: {
            type: Object,
            required: true
        },
        isFrivilligContext: {
            type: Boolean,
            required: false
        },
        handlePostClick: {
            type: Function,
            required: true
        },
    },
    setup(props) {
        const store = useStore()
        const userInfoExpanded = ref(false)
        const isMasked = computed(() => !props.result.postText)

        const latestComment = computed(() => store.state.forum.post_latest_comment[props.result.id])
        const statistics = computed(() => store.state.forum.post_statistics[props.result.id])
        const commentsCount = computed(() => props.result.hasComments ? statistics.value?.commentsCount : 0)
        
        const overlayContent = props.isFrivilligContext
            ? "MemberOverlayProfileCard"
            : "MemberOverlay"
        
        const startUserInfoOverlay = (e, userId) => {
            if (!userId) {
                return
            }

            store.commit('main/set_page_overlay_content_data', { 
                userId,
                isFrivilligContext: props.isFrivilligContext })

            store.dispatch("main/openPageOverlay", {
                overlayContent: overlayContent,
                returnTarget: e.currentTarget,
            })
        }

        onMounted(() => {

            if (props.result.hasComments) {
                store.dispatch("forum/getPostLatestComment", {
                    postId: props.result.id
                })
                store.dispatch("forum/getPostStatistics", {
                    postId: props.result.id
                })
            }

        })
        
        return {
            getLabel: (labelKey)=> store.getters['labels/getLabel']({labelCollection: "GroupPost", labelKey: labelKey}),
            userInfoExpanded,
            isMasked,
            startUserInfoOverlay,
            latestComment,
            commentsCount,
        }
    }
}